import { render, staticRenderFns } from "./DoctorOrder.vue?vue&type=template&id=5f8149a6&scoped=true"
import script from "./DoctorOrder.vue?vue&type=script&lang=js"
export * from "./DoctorOrder.vue?vue&type=script&lang=js"
import style0 from "./DoctorOrder.vue?vue&type=style&index=0&id=5f8149a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8149a6",
  null
  
)

export default component.exports